export default __webpack_public_path__ + "49cbac2fd7ab06838d0ca39848bab8d2.png";